let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jvpmI")).then(() => parcelRequire('50EZL'));